import { RETURN_METHOD, WHO_PAY_SHIPPING_FEE } from 'constants/ordersReturn';
import pick from 'lodash/pick';

const SHIPPING_FEE_DEFAULT = 25000;

export const getTotalAmount = (variantsApplied) =>
  variantsApplied?.reduce(
    (total, currentItem) => total + (currentItem || 0),
    0,
  ) || 0;

export const formatShippingOptions = (data) =>
  Object.entries(pick(data, ['in1Day', 'in3Days', 'in2h'])).map(
    ([key, value]) => ({
      key,
      value,
      available: value > -1,
      text: `shippingFee.${key}`,
    }),
  );

export const formatVariantsItemsSubmit = (results) =>
  results?.items?.map((item) => ({
    variantId: item.variantId,
    quantity: item.quantity || 1,
    isGift: item.isGift,
    promotionId: item.promotionId,
  }));

export const calculateMoney = (whoPayShippingFee, returnMethod) => {
  if (
    whoPayShippingFee === WHO_PAY_SHIPPING_FEE['CUSTOMER'].value &&
    returnMethod === RETURN_METHOD['PICKUP'].value
  ) {
    return -SHIPPING_FEE_DEFAULT;
  }

  if (
    whoPayShippingFee === WHO_PAY_SHIPPING_FEE['ROUTINE'].value &&
    returnMethod === RETURN_METHOD['DROP_OFF'].value
  ) {
    return +SHIPPING_FEE_DEFAULT;
  }

  return 0;
};

export const calculateShippingFeeFnc = (reason) => {
  switch (reason) {
    case 'NO_LONGER_NEEDED':
      return 30000;
    case 'DIFFERENT_MODEL':
      return 35000;
    default:
      return 0;
  }
};
